import _ from 'lodash';
import constants from './constants';

const pricepoint = {
  name: 'pricepoint',
  logo: '//cdn.pricepointmoves.com/public/PricePoint-logo.png',
  primary1Color: '#002D5C',
  accent1Color: '#009BDE',
  primary2Color: '#009D4E',
  primary3Color: '#ED7700',
  logoBGColor: '#002D5C',
  backgroundColor: '#f2f2f8',
  fontWeightMedium: 500,
};

const atlantic = {
  name: 'atlantic',
  logo: '//cdn.pricepointmoves.com/public/AtlanticIntlLogo.png',
  primary1Color: '#007ebd',
  accent1Color: '#cf1238',
  primary2Color: '#005696',
  primary3Color: '#021b28',
  logoBGColor: '#007ebd',
  backgroundColor: '#f2f2f8',
  fontWeightMedium: 500,
};

const cend = {
  name: 'cend',
  logo: '//cdn.pricepointmoves.com/public/CendPPLogo.png',
  primary1Color: '#2d5ca8',
  accent1Color: '#80bc00',
  primary2Color: '#009fdc',
  primary3Color: '#243746',
  logoBGColor: '#2d5ca8',
  backgroundColor: '#f2f2f8',
  fontFamily: 'Arial',
  fontWeightMedium: 600,
};

export const brands = {
  pricepoint,
  atlantic,
  cend,
};

const initialState = {
  brand: brands.cend,
};

export default function brand(state = initialState, action) {
  switch (action.type) {
    case constants.actions.RECEIVE_BRAND:
      return {
        ...state,
        brand: _.isNil(brands[action.brand]) ? brands.cend : brands[action.brand],
      };
    default:
      return state;
  }
}
